import axios from 'axios';

/* eslint no-param-reassign: ["error"] */
const currentState = {
  threads: [],
};

const mutations = {
  set_threads(state, { threads }) {
    state.threads = threads;
  },
};

const actions = {
  async getThreads({ commit }) {
    try {
      const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/messages`);
      commit('set_threads', { threads: data });
    } catch ({ response }) {
      console.log(response);
    }
  },
  async getThread({ commit }, id) {
    try {
      const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/messages/${id}`);
      return true;
    } catch ({ response }) {
      console.log(response);
    }
  },
  async createThread({ commit, dispatch }, form) {
    try {
      const { data } = await axios.post(`${process.env.VUE_APP_API_URL}/messages`, form);
      dispatch('getThreads');
    } catch ({ response }) {
      console.log(response);
    }
  },
  async postAnswer({ commit, dispatch }, { form, id }) {
    try {
      const { data } = await axios.put(`${process.env.VUE_APP_API_URL}/messages/${id}`, form);
      dispatch('getThreads');
    } catch ({ response }) {
      console.log(response);
    }
  },
};

const getters = {
  threads: state => state.threads,
  getThreadById: state => id => state.threads.find(thread => thread.id == id),
};

export default {
  namespaced: true,
  state: currentState,
  getters,
  actions,
  mutations,
};
